import { FormikProps } from "formik"
import { ServiceCustomForm } from "../types/service.type"
import { calculateAge } from "../utils/formatter"
import { getReadablePrimaryButtonStyle } from "../utils/buttonColor"

const fieldClass =
  'mt-1.5 w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm font-medium text-gray-900 shadow-sm transition-colors placeholder:text-gray-400 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-slate-300/80'
const labelClass = 'text-sm font-medium text-gray-700'
const errorTextClass = 'mt-1.5 text-sm text-red-600'

export function CustomForm({ form, formik, themeColor = '#ED1B2E' }: { form: ServiceCustomForm, formik: FormikProps<any>, themeColor?: string }) {
  if (form.type === 'choices') {
    return (
      <div className="space-y-2">
        <div>
          <span className={labelClass}>{form.label}</span>
          {form.instruction ? (
            <span className="ml-1.5 text-xs font-normal text-gray-500">({form.instruction})</span>
          ) : null}
        </div>
        <div className="flex flex-wrap gap-2.5">
          {form.choices.map((choice, index) => {
            const isActive = formik.values.customForm?.[form.key] === choice
            return (
              <button
                key={index}
                type="button"
                name={`customForm.${form.key}`}
                aria-pressed={isActive}
                onClick={() => formik.setFieldValue(`customForm.${form.key}`, choice)}
                className={`rounded-xl border px-5 py-3 text-sm font-semibold transition-colors ${
                  isActive ? '' : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
                }`}
                style={
                  isActive
                    ? { ...getReadablePrimaryButtonStyle(themeColor), borderColor: themeColor }
                    : undefined
                }
              >
                {choice}
              </button>
            )
          })}
        </div>
        {/* @ts-ignore */}
        {formik.touched.customForm?.[form.key] && formik.errors.customForm?.[form.key] ? (
          // @ts-ignore
          <p className={errorTextClass}>{String(formik.errors.customForm?.[form.key])}</p>
        ) : null}
      </div>
    )
  }

  const isDob = form.type === 'dob'
  const inputType = isDob ? 'date' : form.type
  const dobValue = isDob ? formik.values.customForm?.[form.key] : null
  const age = isDob ? calculateAge(dobValue) : null

  return (
    <div className="space-y-0.5">
      <div>
        <label className={labelClass} htmlFor={`custom-form-${form.key}`}>
          {form.label}
        </label>
        {form.instruction ? (
          <span className="ml-1.5 text-xs font-normal text-gray-500">({form.instruction})</span>
        ) : null}
      </div>
      <input
        id={`custom-form-${form.key}`}
        type={inputType}
        name={`customForm.${form.key}`}
        value={formik.values.customForm?.[form.key] || ''}
        className={fieldClass}
        onChange={formik.handleChange}
      />
      {isDob && age != null ? (
        <p className="mt-1.5 text-xs font-medium text-gray-600">
          Usia: <span className="font-semibold text-gray-800">{age} tahun</span>
        </p>
      ) : null}
      {/* @ts-ignore */}
      {formik.touched.customForm?.[form.key] && formik.errors.customForm?.[form.key] ? (
        // @ts-ignore
        <p className={errorTextClass}>{String(formik.errors.customForm?.[form.key])}</p>
      ) : null}
    </div>
  )
}
